<i18n src="./resources/locales.json"></i18n>

<template>
  <v-container fluid>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >{{ $t('subServicesOf') }} {{ service.name }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="addSubService">
              {{ $t('newSubService') }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="allSubServicesByServiceId(service.id)"
            sort-by="name"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.price`]="{ item }">
              {{ item.price | currency(item.currencyCode) }}
            </template>
            <template v-slot:[`item.fixedPrice`]="{ item }">
              <v-simple-checkbox
                :value="item.fixedPrice"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`item.fixedQuantity`]="{ item }">
              <v-simple-checkbox
                :value="item.fixedQuantity"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon
                small
                class="mr-2"
                color="primary"
                @click="editSubService(item)"
              >
                mdi-pencil
              </v-icon>
              <!--v-icon
                small
                class="mr-2"
                color="primary"
                @click="deleteSubService(item)"
              >
                mdi-delete
              </v-icon-->
            </template>
            <template v-slot:no-data>
              <p>
                {{ $t('thereAreNoSubServices') }}
              </p>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <ServiceDetailModal ref="serviceDetailModal" />
    <DeleteConfirmModal
      ref="deleteSubServiceModal"
      @confirm-action="deleteSubServiceConfirm"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ServiceDetailModal from '@/components/service/service-detail-modal/ServiceDetailModal.vue';
import DeleteConfirmModal from '@/components/reusable-components/delete-confirm-modal/DeleteConfirmModal.vue';

export default {
  name: 'SubServiceListModal',

  components: { ServiceDetailModal, DeleteConfirmModal },

  data: () => ({
    dialog: false,
    service: {
      id: -1
    },
    defaultSubService: {
      id: '-1',
      name: '',
      price: null,
      currencyCode: '',
      quantity: null,
      fixedPrice: false,
      fixedQuantity: false,
      serviceId: null
    }
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('subService'),
          value: 'name',
          align: 'center'
        },
        {
          text: this.$t('currency'),
          value: 'currencyCode',
          align: 'center'
        },
        { text: this.$t('price'), value: 'price', align: 'center' },
        {
          text: this.$t('fixedPrice'),
          value: 'fixedPrice',
          align: 'center'
        },
        {
          text: this.$t('quantity'),
          value: 'quantity',
          align: 'center'
        },
        {
          text: this.$t('fixedQuantity'),
          value: 'fixedQuantity',
          align: 'center'
        },
        {
          text: this.$t('actions'),
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ];
    },

    ...mapGetters('services', ['allSubServicesByServiceId'])
  },

  methods: {
    ...mapActions('services', ['removeSubService']),

    open(service) {
      this.service = Object.assign({}, service);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    addSubService() {
      this.defaultSubService.serviceId = this.service.id;
      this.$refs.serviceDetailModal.open(
        Object.assign({}, this.defaultSubService)
      );
    },

    editSubService(subServiceToUpdate) {
      this.$refs.serviceDetailModal.open(Object.assign({}, subServiceToUpdate));
    },

    deleteSubService(subServiceToDelete) {
      this.$refs.deleteSubServiceModal.open(
        Object.assign(
          { message: this.$t('sureToDeleteThisSubService') },
          subServiceToDelete
        )
      );
    },

    deleteSubServiceConfirm(subServiceToDeleteId) {
      this.removeSubService(subServiceToDeleteId);
    }
  }
};
</script>
